/* tslint:disable */
/* eslint-disable */
/**
 * channels-com
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
  Category,
  CategoryFromJSON,
  CategoryFromJSONTyped,
  CategoryToJSON,
} from './';

/**
 *
 * @export
 * @interface ListCategoriesResponse
 */
export interface ListCategoriesResponse {
  /**
   *
   * @type {string}
   * @memberof ListCategoriesResponse
   */
  message: string;
  /**
   *
   * @type {Array<Category>}
   * @memberof ListCategoriesResponse
   */
  categories: Array<Category>;
}

export function ListCategoriesResponseFromJSON(
  json: any
): ListCategoriesResponse {
  return ListCategoriesResponseFromJSONTyped(json, false);
}

export function ListCategoriesResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ListCategoriesResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    message: json['message'],
    categories: (json['categories'] as Array<any>).map(CategoryFromJSON),
  };
}

export function ListCategoriesResponseToJSON(
  value?: ListCategoriesResponse | null
): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    message: value.message,
    categories: (value.categories as Array<any>).map(CategoryToJSON),
  };
}
